<template>

    <div class="row">
      <form>
        <div class="col-xs-12">

            <div class="form-group input-box-bank input-box-control">
              <div class="label-box-sm"><label>Banco:*</label></div>
              <div class="input-box">
                <dropdown class="dropdown-payment block margin-t5"
                          :options="options"
                          v-on:itemSelected="onItemSelected"
                          :value="selectOption"
                          fieldValue="paymentMethodId"
                          fieldCaption="name">
                </dropdown>
              </div>
            </div>

            <div class="">
              <div class="form-group margin-b30 input-box-control inline input-box-number" :class="{'has-error': errors.has('agency')}">
                <div class="label-box-sm"><label>Agência:*</label></div>
                <div class="input-box">
                  <input type="text" name="agency" v-model="bankAccount.agencyNumber" v-validate="'required|min:3'" maxlength="11" class="form-control small">
                </div>
                <div class="help-block">
                  {{ errors.first('agency') }}
                </div>
              </div>

              <div class="form-group margin-b30 input-box-control inline input-box-adjunct" :class="{'has-error': errors.has('accountNumber')}">
                <div class="label-box-sm"><label>Conta:*</label></div>
                <div class="input-box">
                  <input type="text" name="accountNumber" v-model="bankAccount.accountNumber" v-validate="'required|min:3'" maxlength="20" v-only-numbers class="form-control small">
                </div>
                <div class="help-block">
                  {{ errors.first('accountNumber') }}
                </div>
              </div>

              <div class="form-group margin-b30 input-box-control inline input-box-state" :class="{'has-error': errors.has('accountDigit')}">
                <div class="inline"><label>-</label></div>
                <div class="input-box">
                  <input type="text" name="accountDigit" v-model="bankAccount.accountDigit" v-validate="'required'" maxlength="3" v-only-numbers class="form-control small">
                </div>
                <div class="help-block">
                  {{ errors.first('accountDigit') }}
                </div>
              </div>
            </div>

            <div v-if="bankAccount && bankAccount.paymentMethodId == 3" class="alert alert-info margin-b10" style="margin-top: 1%;">
              <strong>Atenção cliente Itaú!</strong><br>Não esqueça de autorizar a MOVE MAIS MEIOS DE PAGAMENTO LTDA a realizar débito automático em sua conta.
              <br>
              <span>  Para mais informações, entre em contato com a Central de Relacionamento pelo número 4000 2901 (regiões metropolitanas) ou 0800 777 1022 (demais localidades).</span>
            </div>

            <!-- <div class="form-group margin-t20" :class="{'has-error': errors.has('agency')}">
              <label class="bold" for="">Agência:</label>
              <input class="form-control number" type="text" name="agency" v-model="bankAccount.agencyNumber" v-validate="'required|min:3'" maxlength="20">
              <div class="help-block">
                {{ errors.first('agency') }}
              </div>
            </div>

            <div class="form-group" :class="{'has-error': errors.has('accountNumber')}" style="display: inline-block">
              <label class="bold" for="">Conta:</label>
              <input class="form-control number" type="text" name="accountNumber" v-model="bankAccount.accountNumber" v-validate="'required|min:3'" maxlength="20" v-only-numbers>
              <div class="help-block">
                {{ errors.first('accountNumber') }}
              </div>
            </div>
            <div class="form-group" :class="{'has-error': errors.has('accountDigit')}" style="display: inline-block">
              <label class="bold" for="">Digito:</label>
              <input class="form-control number" type="text" name="accountDigit" v-model="bankAccount.accountDigit" v-validate="'required'" maxlength="3" v-only-numbers>
              <div class="help-block">
                {{ errors.first('accountDigit') }}
              </div>
            </div> -->

        </div>
      </form>
    </div>
</template>
<style scoped lang="scss">
  .form-group.right {
    margin-left: 20px;
  }
  .form-control {
    &.number, &.name, &.csc {
      height: 40px;
    }
    &.number {
      width: 170px;
    }
    &.name {
      width: 250px;
    }
    &.csc {
      width: 75px
    }
    &.month, &.year {
      display: inline;
    }
  }
  .help-block {
    position: absolute;
  }
  .dropdown-payment.block {
    display: block;
  }
  .input-box-adjunct,
  .input-box-number {
    .help-block {
      margin-left: 100px;
    }
  }
  @media (max-width: 500px) {
    .input-box-bank .input-box {
      width: 100%;
    }
    .input-box-number,
    .label-box-sm {
      display: block;
    }
    .label-box-sm {
      text-align: left;
    }
  }
</style>
<script>
  import addressComp from '../../common/address.vue'

  export default {
    props:['valueStart', 'planId'],
    data(){
      return {
        bankAccount: {
          agencyNumber: "",
          accountNumber:"",
          accountDigit:"",
          paymentMethod: {
            paymentMethodId: ""
          }
        },
        itemSelected: undefined,
        options: []
      }
    },
    created: function(){
      if(this.valueStart){
        this.bankAccount = this.valueStart;
      }

      this.$watch('bankAccount', () => {
         this.emitBankAccount();
      }, { deep: true });

      this.options = this.$store.getters.getBankOptionsByPlan(this.planId);
    },
    computed:{
      selectOption(){
        if(this.bankAccount && this.bankAccount.paymentMethodId)
          return this.bankAccount.paymentMethodId;

        if(this.options && this.options.length)
          return this.options[0].paymentMethodId;

          return "";
      }
    },

    methods:{
      onItemSelected(item){
        
        this.itemSelected = item;
        this.emitBankAccount();
      },

      emitBankAccount(){
        let vm = this;
        if('item selecionado ', vm.itemSelected){
          
          vm.bankAccount.paymentMethod = {};
          vm.bankAccount.paymentMethod.paymentMethodId = vm.itemSelected.paymentMethodId;
          vm.bankAccount.validForm = true;
          vm.bankAccount.imagePath = vm.itemSelected.imagePath;
          vm.bankAccount.name = vm.itemSelected.name;
        }
        vm.$emit('input', vm.bankAccount);

      }
    },
    components: {
      addressComp
    }
  }
</script>



// WEBPACK FOOTER //
// bank-account.vue?40f9a691